import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { saveTokens } from '../guards/guard.functions';
import { logout } from '../store/auth/auth.actions';
import { ApiService } from './api.service';
import { ApiWebSocketService } from './api.web-socket.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  refreshTokenInProgress = false;
  tokenRefreshedSource = new Subject();
  tokenRefreshed$ = this.tokenRefreshedSource.asObservable();

  constructor(
    private store: Store,
    private api: ApiService,
    private wsService: ApiWebSocketService
  ) {}

  addAuthHeader(request: any) {
    if (!request.url.includes('refresh')) {
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${localStorage['accessToken']}`,
        },
      });
    } else {
      return request;
    }
  }

  refreshToken(): Observable<any> {
    if (this.refreshTokenInProgress) {
      return new Observable((observer) => {
        this.tokenRefreshed$.subscribe(() => {
          observer.next();
          observer.complete();
        });
      });
    } else {
      this.refreshTokenInProgress = true;
      return this.api.auth('refresh').pipe(
        tap((res) => {
          if (saveTokens(res, this.wsService)) {
            this.refreshTokenInProgress = false;
            this.tokenRefreshedSource.next();
          }
        }),
        catchError((): any => {
          this.refreshTokenInProgress = false;
          this.useLogout();
        })
      );
    }
  }

  useLogout() {
    this.store.dispatch(logout());
  }

  handleResponseError(error: any, request?: any, next?: any): any {
    if (error.status === 451) {
      // this.useLogout();
    } else if (error.status === 403) {
      return this.refreshToken().pipe(
        switchMap(() => {
          request = this.addAuthHeader(request);
          return next.handle(request);
        }),
        catchError((e) => {
          //this.useLogout();
          return e;
        })
      );
    }

    return throwError(error);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    // Handle request
    request = this.addAuthHeader(request);

    // Handle response
    return next.handle(request).pipe(
      catchError((error) => {
        return this.handleResponseError(error, request, next);
      })
    );
  }
}

export const AuthInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: TokenInterceptor,
  multi: true,
};
